export default __webpack_public_path__ + "static/button-alignment-modal-e8f811d2db2ef8d999ce0acae8c057cc9f547554111652d8ec2fb2f4c5b2c99a.png";